import Model from './model';
import Sequence from './sequence';
import Material from './material';
import Layer from './layer';
import Texture from './texture';
import TextureAnimation from './textureanimation';
import Geoset from './geoset';
import GeosetAnimation from './geosetanimation';
import Bone from './bone';
import Light from './light';
import Helper from './helper';
import Attachment from './attachment';
import ParticleEmitter from './particleemitter';
import ParticleEmitter2 from './particleemitter2';
import ParticleEmitterPopcorn from './particleemitterpopcorn';
import RibbonEmitter from './ribbonemitter';
import Camera from './camera';
import EventObject from './eventobject';
import CollisionShape from './collisionshape';
import UnknownChunk from './unknownchunk';
import TokenStream from './tokenstream';
import { isMdx, isMdl } from './isformat';

export default {
  Model,
  Sequence,
  Material,
  Layer,
  Texture,
  TextureAnimation,
  Geoset,
  GeosetAnimation,
  Bone,
  Light,
  Helper,
  Attachment,
  ParticleEmitter,
  ParticleEmitter2,
  ParticleEmitterPopcorn,
  RibbonEmitter,
  Camera,
  EventObject,
  CollisionShape,
  UnknownChunk,
  TokenStream,
  isMdx,
  isMdl,
};
